import { observer } from 'mobx-react-lite';
import { SeparatorProps } from './separator.types';
import { StyledSeparator } from './separator.styled';

export const Separator = observer(
  ({ vertical = false, fill = 'gray.200', ...restProps }: SeparatorProps) => {
    return <StyledSeparator {...restProps} $vertical={vertical} $fill={fill} />;
  }
);
